import React from 'react'
import { inject, observer } from 'mobx-react'

import { CustomSelect     } from '../../components/select'

export const PostalSelector = inject('postalStore')(observer(({postalStore,...props}) =>
<CustomSelect {...props}
  options={postalStore.options}
/>))
